<div id="container">
    <div id="content">
        <div id="headerContainer">
            <h4 class="mainDarkBlueText normalFontWeight">
                {{ "ACTIVE_USERS_PER_DAY" | translate }}
            </h4>
            <statistics-png-download-btn [widget]="this" />
        </div>

        <div id="chartContainer">
            <canvas id="activeUsersPerDayChart" height="290px"></canvas>
        </div>
    </div>
</div>
